module.exports = __webpack_public_path__ + "static/img/increment03.886d4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/increment03.png
// module id = 7nup
// module chunks = 0